import { Box } from "@chakra-ui/react";

/**
 * Switch — pill toggle matching `.ra-switch` in the redesign bundle.
 * design ref: styles.css:2948–2970, bulk-request.jsx:1062
 *
 * Track 36×20, thumb 16×16 at top:2/left:2. On state slides thumb +16px and
 * paints the track success.500. Built from Box (not Chakra `Switch`) for
 * pixel-level control over the thumb shadow + transform.
 */
export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}

const Switch = ({
  checked,
  onChange,
  disabled,
  "aria-label": ariaLabel,
}: SwitchProps) => {
  return (
    <Box
      as="button"
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      width="36px"
      height="20px"
      borderRadius="full" // 100px
      bg={checked ? "success.500" : "neutral.300"}
      border="none"
      padding={0}
      position="relative"
      cursor={disabled ? "not-allowed" : "pointer"}
      flexShrink={0}
      transition="background-color 160ms"
      opacity={disabled ? 0.5 : 1}
      _focusVisible={{
        outline: "none",
        boxShadow: "focusRing",
      }}
    >
      <Box
        position="absolute"
        top="2px"
        left="2px"
        width="16px"
        height="16px"
        borderRadius="full"
        bg="white"
        boxShadow="0 1px 2px rgba(16,24,40,0.2)"
        transition="transform 160ms"
        transform={checked ? "translateX(16px)" : "translateX(0)"}
      />
    </Box>
  );
};

export default Switch;
